import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'pcln-design-system'

import { LoadingText } from '../LoadingText'

const StyledLoadMoreButton = styled(Button)`
  display: flex;
  justify-content: center;
  margin: 0 8px;
  width: calc(100% - 16px);
  ${props => props.theme.mediaQueries.xl} {
    margin: 0;
    width: 100%;
  }
`

class LoadMoreBtn extends React.Component {
  render() {
    const viewMoreFlightsText = 'View More Flights'

    return (
      <StyledLoadMoreButton
        onClick={this.props.onClick}
        size={'large'}
        disabled={this.props.requestPending}
      >
        {this.props.requestPending ? (
          <LoadingText color='background.lightest' />
        ) : (
          <span data-testid={'view-more-button'}>{viewMoreFlightsText}</span>
        )}
      </StyledLoadMoreButton>
    )
  }
}

LoadMoreBtn.propTypes = {
  requestPending: PropTypes.bool,
  onClick: PropTypes.func,
}

export { LoadMoreBtn }
